import MathHtml from 'components/imported-assessment/MathHtml'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {isEmpty} from '../../../helpers/utils'

const useStyles = makeStyles(sectionStyles)
 
export default function Section ({sections, context}) {

  const {sectionId, translate} = context

  const classes = useStyles()

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const title = isEmpty(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title

  const instructions = section && (isEmpty(section.instructions) ? false: section.instructions)
  const defaultInstructions = translate('default-section-instructions')
  const hasDefaultInstructions = defaultInstructions != 'default-section-instructions'

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.title}>{title}</Box>
      </Box>
      <Box className={classes.content}>
        {(instructions || hasDefaultInstructions) && (<Box className={classes.label}>{translate('instructions')}</Box>)}
        {instructions && (context.importedMath ? <MathHtml className={classes.instructions} html={instructions} /> : <div className={classes.instructions} dangerouslySetInnerHTML={{__html: instructions}} />)}
        {!instructions && hasDefaultInstructions && <Box className={classes.instructions}>{defaultInstructions}</Box>}
      </Box>
    </Box>
  )
}

function sectionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      color: '#525b6c',
    },
    header: {
      display: 'flex',
      fontSize: '13pt',
      padding: '10px 20px',
      borderBottom: 'solid 1px #d0d5d8',
    },
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      padding: '90px 120px',
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      fontWeight: 'bold',
      fontSize: '12pt',
      marginBottom: 40
    },
    instructions: {
      fontSize: '11pt'
    }
  }
}
